import ArtifactGroupType from "../base/ArtifactGroupType";


const BronzeShellCoins = {
  id: '111',
  name: 'Bronze Shell Coins',
  groupIcon: 'WhispersOfJade',
  type: ArtifactGroupType.WHISPERS_OF_JADE,
  icon: 'BronzeShellCoins',
  power: 10
};

export default BronzeShellCoins;
